module.exports = __webpack_public_path__ + "static/media/IconDarkMode.7cfd8068.svg";